<template>
    <div>
        <!-- <img class="header-image" :src="require(`/src/assets/images/${filename}`)" alt=""> -->
    </div>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      default: 'order-scan.png' // ../assets/images/order-scan.png
    }
  }
}
</script>

<style scoped lang="scss">
    .header-image {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/Banner.vue